/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemPreviews_viewer$ref = any;
export type Tiles_viewer$ref = any;
export type Tiles_viewer = {
    readonly " $fragmentRefs": ItemPreviews_viewer$ref;
    readonly " $refType": Tiles_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "Tiles_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ItemPreviews_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '654b0c93667758adb3df152899f4d739';
export default node;
